// Optional paid layer. The free engine (smartImport + categorizer) does the
// work first; AI is only asked about what it couldn't place, and only through
// a server-side function — the model key never exists in browser code.
import { supabase, syncConfigured } from "./supabaseClient.js";

export const AI_FEATURE_NAME = "Smart AI import";
// Where the "Upgrade" button sends people (Stripe Payment Link, Gumroad, etc.)
export const UPGRADE_URL = "";

async function call(body) {
  if (!syncConfigured) throw new Error("Sign in to use AI import.");
  const { data, error } = await supabase.functions.invoke("ai-import", { body });
  if (error) {
    // Edge Functions put the useful message in the response body
    let msg = error.message || "AI import failed";
    try { const j = await error.context?.json?.(); if (j?.error) msg = j.error; } catch (e) { /* keep default */ }
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

// Merchant names only — never amounts or dates — go to the model.
export async function aiCategorize(merchants, categories) {
  const data = await call({ mode: "categorize", merchants: merchants.slice(0, 120), categories });
  const out = {};
  const valid = new Map(categories.map((c) => [c.toLowerCase(), c]));
  Object.entries(data.results || {}).forEach(([m, c]) => {
    const hit = valid.get(String(c).toLowerCase());
    if (hit) out[m] = hit;
  });
  return out;
}

// For files the free reader can't make sense of (scans, odd layouts). This one
// does send the statement text, so the UI asks for consent first.
export async function aiExtract(text) {
  const data = await call({ mode: "extract", text: text.slice(0, 30000) });
  return (data.transactions || [])
    .filter((t) => t && /^\d{4}-\d{2}-\d{2}$/.test(t.date) && Number(t.amount) !== 0 && t.description)
    .map((t) => ({ date: t.date, signed: Number(t.amount), desc: String(t.description) }));
}
